/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TrophyIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABl0lEQVR4nN2UO0sDQRDHV3w/PoJ+BkEbuyskEsnuzlxkb8YHpEupoNgLdoJfQisR7aIfIGhvClvBWEbQaLqAsrk7EzWPu+QKceDgZu/m/9uZnVkh/qU5jjOigI8VUEUjf3R77D8K+MgYMxwZoIAOewnr36CDjoLa5YxGfoorqjvDyhJptXXH5aTEdQhBfmxmECwKIYYaPtBpH6IngdxQi14IoFe74Lqbs4G/H78svGdjrUbgvzQBQLdBWp71JdJKXIAEWraxAESNNaBiawa7/o90l8/nR1OprWmNXIux+zdjzKSNVUilxrrL218AY8yMPRSfzBfpdHpcIZ1HzgDoLIi5DCrxIKWc+t77rrcU7trCFFIhesdQIdygQq4ibiy2nQfpegsK+L7/1qRSxvXmu06xX0f2/HTpPUK/V205FVLWXjEijjm53IRG2lHA9TYHW7ffbO3FoKaQ5I+uqmnNWiRpEtbXWmqdFUmbMWYsBNj3xAEANBcCwislWXGg6+Zg8VUiEIV8E2GKi/0DgJ9730NUGTiTP22f72L7BJ5wc/oAAAAASUVORK5CYII=)
 */
export const TrophyIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M8 20a1 1 0 0 0-1 1v.5c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5V21a1 1 0 0 0-1-1h-1a2 2 0 0 1-2-2v-.48c0-.95.7-1.73 1.5-2.23a5.7 5.7 0 0 0 1.23-1.08l2.3-.7A7 7 0 0 0 23 6.81V6a2 2 0 0 0-2-2h-2.24A2.85 2.85 0 0 0 16 2H8c-1.3 0-2.43.84-2.76 2H3a2 2 0 0 0-2 2v.82a7 7 0 0 0 4.96 6.7l2.31.7c.37.42.79.78 1.24 1.07.8.5 1.49 1.28 1.49 2.23V18a2 2 0 0 1-2 2H8Zm9.29-8.35.17-.05A5 5 0 0 0 21 6.82V6h-2.27a21.75 21.75 0 0 1-1.44 5.65Zm-10.58 0-.17-.05A5 5 0 0 1 3 6.82V6h2.27c.25 1.94.7 3.95 1.44 5.65Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
